import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { JobState } from '../../store/state/job-details.state';
import { jobDetailsLoaded } from '../../store/selectors/job-details.selectors';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { JobDetails } from '../../../models/job-details.model';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-submittal-info',
    templateUrl: './locums-recruiter-submittal-info.component.html',
    styleUrls: ['./locums-recruiter-submittal-info.component.scss']
})
export class LocumsRecruiterSubmittalInfoComponent implements OnInit {
    job: JobDetails;

    constructor(private readonly store: Store<JobState>) {}

    ngOnInit(): void {
        this.store
            .select(jobDetailsLoaded)
            .pipe(
                filter((e) => e.success),
                untilDestroyed(this)
            )
            .subscribe((e) => {
                this.job = e.job;
            });
    }
}
